export default __webpack_public_path__ + "static/media/images/bildschirmfoto.a17828fe.jpg";